import { render, staticRenderFns } from "./DoctorListAll.vue?vue&type=template&id=46a77988&scoped=true"
import script from "./DoctorListAll.vue?vue&type=script&lang=js"
export * from "./DoctorListAll.vue?vue&type=script&lang=js"
import style0 from "./DoctorListAll.vue?vue&type=style&index=0&id=46a77988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a77988",
  null
  
)

export default component.exports